import {
  useContext,
  createContext,
  useCallback,
  useMemo,
  useState,
} from 'react'

type SentinelProviderProps = {
  children: React.ReactNode
}

type ContextType = {
  isOpen: boolean
  openSentinel: () => void
  closeSentinel: () => void
}

const Context = createContext<ContextType>({} as ContextType)

function SentinelProvider({ children }: SentinelProviderProps) {
  const [isOpen, setIsOpen] = useState(false)

  const openSentinel = useCallback(() => setIsOpen(true), [])
  const closeSentinel = useCallback(() => setIsOpen(false), [])

  const sentinelProviderValues = useMemo(
    () => ({ isOpen, openSentinel, closeSentinel }),
    [isOpen, openSentinel, closeSentinel]
  )

  return (
    <Context.Provider value={sentinelProviderValues}>
      {children}
    </Context.Provider>
  )
}

const useSentinel = () => {
  const context = useContext(Context)
  return context
}

export { SentinelProvider, useSentinel }
